// extracted by mini-css-extract-plugin
export default {"searchInput":"permission_searchInput__TDjC5","filterMenu":"permission_filterMenu__9XD-k","permissionModal":"permission_permissionModal__jaeli"};